module.exports = __webpack_public_path__ + "img/content4.09ddf68d.png";